export default __webpack_public_path__ + "static/game-intro-01-040e661ea2ef04bf5f27edf336169dab.png";